<template>
  <div class="detailShare">
    <div class="header"></div>
    <div class="content">
      <div class="card-wrapper">
        <div class="card-item">
          <div class="title">申报高企、双软必要条件</div>
          <div class="desc">高新企业申报，双软认证的必要条件,申报成功后企业可享受国家税收减免、政策 资金扶持等各类优惠政策。</div>
        </div>
        <div class="card-item">
          <div class="title">诉讼纠纷的有力证据</div>
          <div class="desc">在发生争议时证明软件权利的最有力的证据。助力著作权人的权利获得全面保护。</div>
        </div>
        <div class="card-item">
          <div class="title">提升企业无形资产</div>
          <div class="desc">可作为无形资产，用于增资、融资、抵押、技术入股等。</div>
        </div>
        <div class="card-item">
          <div class="title">上线上架必备</div>
          <div class="desc">游戏软件、APP软件等上线时，大多需提交软件著作权登记证书。</div>
        </div>
      </div>

      <div class="tip">
        <div class="left">
          <img src="../../../../static/images/share-icon.png" alt="" />
        </div>
        <div class="right">
          <p>根据版权保护中心规定所有著作权人皆需实名认证，实名信息即为证书上的著作权人信息，认证需要1-3个工作日完成。</p>
          <p>具体操作指引链接如下： <a :href="link" target="_blank">版权保护中心实名认证指引</a></p>
        </div>
      </div>

      <div class="form-wrapper">
        <base-form from="share" :formData.sync="formData" @onSubmit="onSubmit" @saveCase="saveCase" @onShare="onShare" @onFocus="onFocus" @onBlur="onBlur" @onDataChange="onDataChange" @enable="enable" />
      </div>
    </div>
    <cr-loading :loading="loading"></cr-loading>
  </div>
</template>

<script>
import io from 'socket.io-client'
import { randomString } from '@/utils'
import BaseForm from './component/baseForm.vue'
import { caseOverview, saveCase, submitCase } from '@/api/caseDetail'
import { message } from 'ant-design-vue'
let socket = null
export default {
  name: 'CaseDetail',
  data() {
    return {
      formData: {
        fullName: { data: '', enableAt: '0', focusUser: '' },
        shortName: { data: '', enableAt: '0', focusUser: '' },
        versionNo: { data: '', enableAt: '0', focusUser: '' },
        category: { data: '', enableAt: '0', focusUser: '' },
        completionDate: { data: '', enableAt: '0', focusUser: '' }, // 开发完成日期
        publishState: { data: '', enableAt: '0', focusUser: '' }, // 发布状态
        firstPublishDate: { data: '', enableAt: '0', focusUser: '' }, // 首次发表日期
        firstPublishAddress: { data: '', enableAt: '0', focusUser: '' }, // 首次发表地址
        developHardware: { data: '', enableAt: '0', focusUser: '' }, // 开发环境
        productHardware: { data: '', enableAt: '0', focusUser: '' }, // 运行硬件环境
        developOs: { data: '', enableAt: '0', focusUser: '' }, // 开发操作系统
        developTools: { data: '', enableAt: '0', focusUser: '' }, // 软件开发环境
        operatingPlatform: { data: '', enableAt: '0', focusUser: '' }, // 软件运行平台
        supportingEnv: { data: '', enableAt: '0', focusUser: '' }, // 软件支撑环境
        programmingLanguage: { data: '', enableAt: '0', focusUser: '' }, // 编程语言
        sourceCodeCount: { data: '', enableAt: '0', focusUser: '' }, // 源程序量
        developPurpose: { data: '', enableAt: '0', focusUser: '' }, // 开发目的
        fieldOriented: { data: '', enableAt: '0', focusUser: '' }, // 面向领域
        attributes: { data: '', enableAt: '0', focusUser: '' }, // 软件属性
        primaryFunction: { data: '', enableAt: '0', focusUser: '' }, // 主要功能
        technicalFeature: { data: '', enableAt: '0', focusUser: '' }, // 技术特点
        authors: { data: '', enableAt: '0', focusUser: '' }, // 著作权人信息
        contactPerson: { data: '', enableAt: '0', focusUser: '' }, // 联系人信息
        postalAddress: { data: '', enableAt: '0', focusUser: '' }, // 邮寄地址
        postalAddressPrecise: { data: '', enableAt: '0', focusUser: '' }, // 邮寄详细地址
        postalCode: { data: '', enableAt: '0', focusUser: '' }, // 邮政编码
        contactPhone: { data: '', enableAt: '0', focusUser: '' }, // 联系电话
        contactEmail: { data: '', enableAt: '0', focusUser: '' }, // 邮箱地址
        contactLanline: { data: '', enableAt: '0', focusUser: '' }, // 座机电话
        softwareDocument: { data: '', enableAt: '0', focusUser: '' }, // 软件说明文档
        includingEnglish: { data: '', enableAt: '0', focusUser: '' }, // 是否包含英文
        scoreCode: { data: '', enableAt: '0', focusUser: '' }, // 软件源代码
        cooperativeAgreement: { data: '', enableAt: '0', focusUser: '' }, // 合作开发协议
        nameExplanation: { data: '', enableAt: '0', focusUser: '' }, // 名称英文解释
        manualExplanation: { data: '', enableAt: '0', focusUser: '' } // 说明书英文解释
      },
      link: 'http://www.ccopyright.com.cn/index.php?spm=a2c4g.11186623.2.2.4188126dfKfvQ3&optionid=1216&page=2',
      socketConnected: false,
      caseDetail: {},
      saveCaseModal: false,
      shareModal: false,
      hoverCase: false, // 控制复制案件号按钮
      hoverPhone: false, // 控制复制联系人按钮
      shareUrl: '',
      caseNo: '',
      loading: false,
      token: ''
    }
  },
  created() {
    const caseNo = this.$route.query.caseNo
    this.token = `${Date.now()}-${randomString(6)}` // socket需要的token 用来区别用户，无其他鉴权
    this.caseNo = caseNo
    this.getCaseOverview(caseNo)
    this.initSocket(caseNo)
  },
  methods: {
    initSocket(caseNo) {
      const path = process.env.VUE_APP_SOCKET_URL

      socket = io(path, { query: { token: this.token, roomId: caseNo }, transports: ['websocket'] })

      socket.on('connect', () => {
        // this.$message.success('socket 连接成功')
        this.socketConnected = true
      })

      socket.on('reconnect_error', () => {
        console.log('socket 连接错误')
      })

      socket.on('disconnect', () => {
        // this.$message.error('socket 断开连接')
        this.socketConnected = false
      })

      // 监听服务端的事件
      socket.on('init', (data, result) => {
        console.table(data)
        if (data) {
          this.formData = data
        } else {
          message.error({
            content: result || '案件异常！',
            duration: 2,
            onClose: () => {
              this.$router.replace(`/cannotShare?caseNo=${this.caseNo}`)
            }
          })
        }
      })

      // 广播事件
      socket.on('broadcast', (broadcastData) => {
        if (typeof broadcastData === 'string') {
          broadcastData = JSON.parse(broadcastData)
        }
        console.table(broadcastData)
        // enableAt = '1'的情况 不能赋值给表单
        for (const key in broadcastData) {
          if (Object.hasOwnProperty.call(broadcastData, key)) {
            const value = broadcastData[key]
            if (value.focusUser != this.token) {
              this.formData[key] = value
            }
          }
        }
      })
    },
    // 获取案件基本信息
    async getCaseOverview(caseNo) {
      this.loading = true
      try {
        const res = await caseOverview(caseNo)
        this.loading = false
        this.caseDetail = res.data
      } catch (error) {
        this.loading = false
      }
    },
    // 提交案件
    async onSubmit() {
      const caseDetail = this.caseDetail
      const reqData = {
        caseDetailId: caseDetail.caseDetailId,
        caseNo: caseDetail.caseNo,
        childState: caseDetail.childState,
        state: caseDetail.state,
        token: this.token,
        ...this.formData
      }
      this.loading = true
      const res = await submitCase(reqData).catch((err) => {
        this.loading = false
      })
      this.loading = false
      this.saveCaseModal = false
      if (res.code == 0) {
        this.$message.success('案件已提交成功、请等待平台审核。')
      }
    },
    // 保存案件
    async saveCase(flag) {
      const caseDetail = this.caseDetail
      const reqData = {
        caseDetailId: caseDetail.caseDetailId,
        caseNo: caseDetail.caseNo,
        childState: caseDetail.childState,
        state: caseDetail.state,
        token: this.token,
        ...this.formData
      }
      this.loading = true
      const res = await saveCase(reqData)
      this.loading = false
      console.log(res)
      if (res.code == 0) {
        if (flag && this.caseDetail.transState === 1) {
          this.saveCaseModal = true
        } else {
          this.$message.success('案件信息保存成功')
        }
      }
    },
    onShare() {
      this.shareUrl = location.origin + '/detailShare?caseNo=' + this.caseNo
      this.shareModal = true
    },
    // 复制成功
    copySuccess() {
      this.$message.success('复制成功')
      this.shareModal = false
    },

    // 针对非输入框表单类型 同步数据
    onDataChange(data) {
      const target = data.target
      // 以下三个字段是引用类型，需要序列化后传给后端，同时要同步本地formData中的数据
      if (target == 'firstPublishAddress' || target == 'postalAddress' || target == 'authors') {
        this.formData[target]['data'] = JSON.stringify(data.data)
      }
      this.socketConnected && socket.emit('syncData', JSON.stringify(data))
    },
    onFocus(key) {
      // 约定：输入框触发聚焦事件，通知后台禁用当前输入框
      console.log('禁用：', key)
      this.socketConnected && socket.emit('disable', key)
    },
    // 启用按钮
    enable(key) {
      this.socketConnected && socket.emit('enable', key)
    },
    // 针对 输入框类型 同步数据
    onBlur(key) {
      // 约定：输入框触发失焦事件，想后台同步数据。
      let syncData = {
        target: key,
        data: this.getFormDataByKey(key)
      }
      console.log('同步数据：', syncData)
      this.socketConnected && socket.emit('syncData', JSON.stringify(syncData))
    },
    getFormDataByKey(key) {
      return this.formData[key]['data'] || ''
    }
  },
  beforeDestroy() {
    if (socket) socket.disconnect()
  },
  components: {
    BaseForm
  }
}
</script>

<style lang="less" scoped>
.detailShare {
  height: 100%;
  overflow-y: auto;
  padding-bottom: 68px;
  .header {
    height: 572px;
    background: url('../../../../static/images/shareDetail.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .content {
    width: 1200px;
    margin: -290px auto 0;

    .card-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;
      .card-item {
        width: 285px;
        height: 162px;
        background: #ffffff;
        box-shadow: 0px 0px 10px 0px rgba(2, 88, 94, 0.15);
        border-radius: 10px;
        opacity: 0.97;
        padding: 20px 16px;
        .title {
          font-size: 18px;
          font-weight: 400;
          color: #333333;
          line-height: 25px;
          margin-bottom: 20px;
        }
        .desc {
          height: 72px;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          line-height: 24px;
        }
      }
    }

    .tip {
      height: 74px;
      background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(2, 88, 94, 0.1);
      border-radius: 10px;
      margin-bottom: 35px;
      padding: 16px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      line-height: 24px;
      display: flex;
      .left {
        width: 20px;
        flex-shrink: 0;
        margin-right: 4px;
        img {
          width: 14px;
          height: 14px;
          vertical-align: middle;
        }
      }
    }
    .form-wrapper {
      border: 1px solid #eaeaea;
      padding: 10px 20px;
    }
  }
}
</style>
